import React from 'react';
import globalHook from 'use-global-hook';
import { MainActionsType } from './models';
import { isEnglish, getPageWidth, getNavbarHeight } from '../utils/helper/helpers';
import { Language } from '../config/models';
import { STYLE } from '../styles/variables';

export interface MainStore {
    language: Language;
    navbarHeight: string;
}

export interface MainActions {
    setNavbarHeight: (height: string) => void;
}

const initialState: MainStore = {
    navbarHeight: getNavbarHeight(STYLE.navbar.sizes, getPageWidth()),
    language: isEnglish() ? Language.EN : Language.DE
};

const actions: MainActionsType = {
    setNavbarHeight(store, height) {
        store.setState({ navbarHeight: height });
    }
};

export const useGlobal = globalHook<MainStore, MainActions>(React, initialState, actions);
